import React from 'react';

const PerfiosCallback = props => {
    const { PUBLIC_URL } = process.env;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isCompleted = params.get('status');

    return (
        <>
            {
                isCompleted === "completed" ?
                    <div className="col-md-12 d-flex">
                        <div className="col-md-6 p-0">
                            <img src="https://mintifi.com/media/logo.png" alt="logo" className="pt-4 mb-4" />
                        </div>
                    </div> : null
            }
            {isCompleted === "completed" || props.msg === "completed" ?
                <>
                    <div className="col-md-12 mrgn52">
                        <div>
                            <h2 className="thankyou-main-text">Thank You!</h2>
                            <p className="thankyou-inner-text">Your Bank Statement is submitted</p>
                        </div>
                        <div className="col-md-12 mt-5">
                            <div className="text-center mb-5">
                                <img src="/images/message popup.png" alt="message" className="imgWidth" style={{ height: 253 }} />
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="col-md-12 mrgn52">
                        <div>
                            <h2 className="something-wrong-text">Something went wrong</h2>
                            <p className="something-wrong-inner-text">Please try again later</p>
                        </div>
                        <div className="col-md-12 mt-5">
                            <div className="text-center mb-5">
                                <img src="/images/eror message.png" alt="error" className="imgWidth" style={{ height: 253 }} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 mt-3 d-flex padd0">
                        <div className="col-md-3 paddlr20 cntr m-auto grid padd0">
                            <button type="button" className="btnSubmit pl-4 pr-4" onClick={() => {
                                if (props.msg === "failure")
                                    return window.location.href = `${PUBLIC_URL}/banking${search}`
                                return window.location.href = `${PUBLIC_URL}/banking`
                            }}>Retry <img src="/images/arrow.png" alt="icon" className="ml-3 mb-1 dispNone" /></button>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default PerfiosCallback;